import React, { useEffect, useState } from "react";
import { useLocalStorage } from "../../auth/useLocalStorage";
import { CommonService } from "../../services/CommonService";
import { Dialog, DialogTitle, DialogActions, ToggleButtonGroup, ToggleButton, TextField, Button, CircularProgress, Backdrop } from "@mui/material";
import { CustomerService } from "../../services/CustomerService";
import { Map } from "../Map";
import { useModalStore } from "../../context/modalStore";
import { usePosStore } from "../../context/posStore";
import { IProduct, TRequestSale, PaymentsMethods, ICustomer, IPayment } from "../../common/interfaces";
import { SaleService } from "../../services/SaleService";
import Swal from "sweetalert2";
import "@sweetalert2/theme-dark/dark.css";
import withReactContent from "sweetalert2-react-content";
import { v4 } from "uuid";
import { set } from "lodash";
const MySwal = withReactContent(Swal);

export const OrderOptions: React.FC = () => {
  const modalManager = useModalStore();
  const clearOrder = usePosStore((state) => state.clearOrder);
  // const posCustomer = usePosStore((state) => state.customer);
  const order = modalManager.params?.order;
  const customer = modalManager.params?.customer;
  const pays = modalManager.params?.pays ?? [];

  console.log("Modal params:");
  console.dir(modalManager.params);

  const products = usePosStore((state) => state.products);
  const radioGroupRef = React.useRef<HTMLElement>(null);
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [isLocal, setIsLocal] = React.useState(false);
  const [name, setName] = React.useState("");
  const [dir2, setDir2] = React.useState("");
  const [shippedType, setShippedType] = React.useState("");
  const [openDir2, setOpenDir2] = React.useState(false);
  const [showDir, setShowDir] = React.useState(false);
  const [location, setLocation] = React.useState();
  const [shipping, setShipping] = React.useState(0);
  const [time, setTime] = React.useState("");
  const [user, setUser] = useLocalStorage("user", null);
  const [disableSend, setDisableSend] = useState(false);
  // const [customer, setCustomer] = useState<ICustomer>()
  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handlePhone = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(event.target.value);
    if (event.target.value.length >= 10) {
      CustomerService.getCustomerByPhone(event.target.value).then((res) => {
        if (res.object?.id && res.object?.direccion !== "") {
          setAddress(res.object?.direccion ?? "");
          if (res.object?.direccion2 !== "") {
            setDir2(res.object?.direccion2 ?? "");
          }
          setName(res.object?.nombre ?? "");
          setOpenDir2(true);
        }
      });
    }
  };
  const handleOk = async () => {
    console.log("🔵 [handleOk] Iniciando handleOk");
    console.log("🔵 [handleOk] disableSend actual:", disableSend);

    if (shippedType === "") {
      console.log("❌ [handleOk] Error: No se seleccionó tipo de envío");
      CommonService.displayAlert("Debe seleccionar un tipo de envío");
      return;
    }
    if (phone === "" && shippedType === "shipped") {
      console.log("❌ [handleOk] Error: Teléfono requerido para domicilio");
      CommonService.displayAlert("El teléfono es requerido");
      return;
    }
    if (name === "") {
      console.log("❌ [handleOk] Error: Nombre requerido");
      CommonService.displayAlert("El nombre es requerido");
      return;
    }

    // Validar que la fecha no sea en el pasado
    if (time) {
      const selectedDate = new Date(time);
      const now = new Date();

      if (selectedDate < now) {
        console.log("❌ [handleOk] Error: Fecha en el pasado");
        CommonService.displayAlert("No puedes agendar un pedido en una fecha pasada. Por favor verifica el año y la fecha seleccionada.");
        return;
      }
    }

    if (isLocal) {
      if (address === "") {
        console.log("❌ [handleOk] Error: Dirección requerida");
        CommonService.displayAlert("La dirección es requerida");
        return;
      }
    }

    console.log("✅ [handleOk] Validaciones pasadas, llamando a setInfo");
    setInfo(
      name,
      phone,
      address,
      dir2,
      isLocal,
      shipping,
      shippedType,
      state,
      location,
      time
    );

    console.log("🔵 [handleOk] Limpiando campos del formulario");
    setPhone("");
    setAddress("");
    setDir2("");
    setName("");
    setOpenDir2(false);
    setIsLocal(false);
    setShippedType("");
    setShipping(0);
    setShowDir(false);
    setTime("")
    console.log("🔵 [handleOk] handleOk completado");
    // onClose("OK");
  };

  const setInfo = async (
    nombre: string,
    phone: string,
    address: string,
    dir2: string,
    isLocal: boolean,
    shipping: number,
    shippedType?: string,
    state?: {
      checkDir: boolean;
      checkDir2: boolean;
    },
    location?: any,
    time?: string
  ) => {
    console.log("🟢 [setInfo] Iniciando setInfo");
    console.log("🟢 [setInfo] Estableciendo disableSend = true");
    setDisableSend(true);

    if(customer && customer.rfc !== 'XAXX010101000'){
      console.log("🟢 [setInfo] Cliente existente con RFC válido:", customer);
      await CustomerService.updateCustomerById(customer.id, {
        nombre,
        direccion: address,
        direccion2: dir2,
        telefono: phone,
      });
      console.log("🟢 [setInfo] Cliente actualizado, llamando a createSale");
      createSale(customer, shipping, shippedType, state, location, time)
      console.log("🟢 [setInfo] setInfo completado (NO se resetea disableSend aquí)");
      return
    }
    if (phone) {
      console.log("🟢 [setInfo] Buscando cliente por teléfono:", phone);
      await CustomerService.getCustomerByPhone(phone).then(async (res) => {
        if (res.object) {
          console.log("🟢 [setInfo] Cliente encontrado, actualizando");
          await CustomerService.updateCustomerByPhone({
            nombre,
            telefono: phone,
            direccion: address,
            direccion2: dir2,
          });
          console.log("🟢 [setInfo] Cliente actualizado, llamando a createSale");
          createSale(res.object, shipping, shippedType, state, location, time)
        } else {
          console.log("🟢 [setInfo] Cliente no encontrado, creando nuevo");
          await CustomerService.createCustomer({
            nombre,
            rfc: "XAXX010101000",
            direccion: address,
            telefono: phone,
          }).then((res) => {
            console.log("🟢 [setInfo] Cliente creado, llamando a createSale");
            createSale(res.object, shipping, shippedType, state, location, time)
          });
        }
      });
    } else {
      console.log("🟢 [setInfo] Sin teléfono, creando cliente genérico");
      await CustomerService.createCustomer({
        nombre,
        rfc: "XAXX010101000",
        direccion: address,
        telefono: phone,
      }).then((res) => {
        console.log("🟢 [setInfo] Cliente genérico creado, llamando a createSale");
        createSale(res.object, shipping, shippedType, state, location, time)
        // setCustomer(res.object as ICustomer);
        // setCrateWN("WN");
        // setOpenToOrder(false);
        // setOpenModal(true);
        // createOrder();
      });
    }
    console.log("🟢 [setInfo] setInfo completado (NO se resetea disableSend aquí, createSale lo manejará)");
    // NO establecer disableSend = false aquí, createSale lo hará cuando termine
  };

  const createSale = (ncustomer?: ICustomer, shipping?: number, shippedType?: string | undefined, state?: { checkDir: boolean; checkDir2: boolean; } | undefined, location?: any, time?: string | undefined) => {
    console.log("🟡 [createSale] Iniciando createSale");
    console.log("🟡 [createSale] Estableciendo disableSend = true");
    setDisableSend(true);

    const auxOrder = products.some(
      (product: IProduct) => product.options && product.options.length > 0
    );

    // Filtrar las líneas de servicio de asado - el backend las agregará automáticamente
    const productsToSend = products.filter((product: IProduct) => !product.is_grilling_service);

    console.log('📤 Productos a enviar al backend (orderOptions):', productsToSend.map((p: IProduct) => ({
      id: p.id,
      name: p.name,
      grilling_config: p.grilling_config
    })));

    const data: TRequestSale = {
      orderProducts: productsToSend,
      total: order.total,
      subtotal: order.subtotal,
      iva: order.iva,
      ieps: order.ieps,
      descuento: order.discount,
      metodoPago: "other",
      shipping: shipping ?? 0,
      notes_order: order.notes_order,
      schedule: time,
      cliente: ncustomer ?? customer,
      sale_type: "Order",
      payments: pays,
      user_id: user.id,
      warehouse_id: user.warehouse_id,
      cash_received: 0, //parseFloat(amountReceived),
      cashBox: user.cbox,
      notes: address,
      state,
      location,
      shipped_type: shippedType,
    };

    console.log("🟡 [createSale] Enviando petición al backend...");
    SaleService.createSalePos(data).then((res) => {
      console.log("🟡 [createSale] Respuesta recibida del backend:", res.success);
      if (res.success) {
        console.log("✅ [createSale] Venta creada exitosamente");
        const saleId = res.object?.id ?? 0;
        const paymentTransfer = pays.find(
          (payment: IPayment) => payment.payment_method === PaymentsMethods.Transfer && !payment.is_anticipo)
        const paymentCredit = pays.find(
          (payment: IPayment) => payment.payment_method === PaymentsMethods.Credit);

        // Calcular el total pagado (solo pagos aprobados)
        const totalPaid = pays
          .filter((payment: IPayment) => payment.status === "approved")
          .reduce((sum: number, payment: IPayment) => sum + payment.amount, 0);
        const orderTotal = Number(order.total);
        const isFullyPaid = totalPaid >= orderTotal;

        if (paymentCredit) {
          console.log("🟡 [createSale] Pago a crédito detectado, solicitando autorización");
          const idAuth = v4();
          CommonService.requestAuthorize({
            message: `Se solicita Autorizar un pago a Crédito de $ ${paymentCredit.amount.toFixed(
              2
            )}`, // => $req->message,
            action: {
              type: "authorize-payment",
              item: { order_id: saleId },
              id: idAuth,
              content: `Se solicita Autorizar un pago a Crédito de $ ${paymentCredit.amount.toFixed(
                2
              )}`,
            }, // => $req->action,
            status: "pending", // => 'pending', // Set the initial status
            from: user.id, // => $req->from,
            to: 1, // => $req->to,
          }).then(() => {
            console.log("🟡 [createSale] Autorización solicitada, cerrando modal");
            CommonService.toast(
              "Se envío solicitud de Autorización, para validar pago a Crédito",
              "success"
            );
            modalManager.closeModal();
          });
        } else if (paymentTransfer) {
          console.log("🟡 [createSale] Pago por transferencia detectado, solicitando autorización");
          const idAuth = v4();
          CommonService.requestAuthorize({
            message: `Se solicita Autorizar un pago por Transferencia de $ ${paymentTransfer.amount.toFixed(2)}`, // => $req->message,
            action: {
              type: "authorize-payment",
              item: { order_id: saleId },
              id: idAuth,
              content: `Se solicita Autorizar un pago por Transferencia de $ ${paymentTransfer.amount.toFixed(
                2
              )}`,
            }, // => $req->action,
            status: "pending", // => 'pending', // Set the initial status
            from: user.id, // => $req->from,
            to: 1, // => $req->to,
          }).then(() => {
            console.log("🟡 [createSale] Autorización solicitada, cerrando modal");
            CommonService.toast("Se envío solicitud de Autorización, para validar pago por transferencia", "success")
            modalManager.closeModal();
          });
          // pusher.
        } else if (isFullyPaid) {
          console.log("🟡 [createSale] Pedido completamente pagado, imprimiendo tickets");
          // Solo imprimir ticket si el pedido está completamente pagado
          CommonService.printTicketSale(saleId)
            .then(() => {
              console.log("printing");
              if (auxOrder) {
                CommonService.printTicketOrder(saleId)
                  .then(() => {
                    console.log("printing Comanda");
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          console.log("🟡 [createSale] Cerrando modal y mostrando mensaje de éxito");
          modalManager.closeModal()
          MySwal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          console.log("🟡 [createSale] Pedido con pago pendiente, cerrando modal");
          // Pedido registrado sin pago completo - NO imprimir ticket
          modalManager.closeModal()
          MySwal.fire({
            icon: "success",
            title: "Pedido registrado",
            text: isFullyPaid ? undefined : "El pedido se registró con pago pendiente",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        console.log("🟡 [createSale] Limpiando orden");
        clearOrder();
        // setOpenModal(false)
      } else {
        console.log("❌ [createSale] Error al crear venta:", res.message);
        CommonService.toast(res.message, "error");
      }
      console.log("⚠️ [createSale] ADVERTENCIA: Estableciendo disableSend = false al final de createSale");
      setDisableSend(false);
    });
  };

  
  useEffect(() => {
    if (shippedType === "onSite" || shippedType === "inRoom") {
      setIsLocal(false);
      setShipping(0);
    } else {
      setIsLocal(true);
    }
    if (shippedType !== "") setShowDir(true);
  }, [shippedType]);

  const [state, setState] = React.useState({
    checkDir: true,
    checkDir2: false,
  });
  useEffect(() => {
    console.log("🔄 [useEffect] Componente montado/actualizado");
    console.log("🔄 [useEffect] disableSend:", disableSend);
    if(customer && customer.rfc !== 'XAXX010101000'){
      console.log("🔄 [useEffect] Cargando datos del cliente");
      setPhone(customer.telefono)
      setName(customer.nombre)
      setAddress(customer.direccion)
    }
  }, [])

  useEffect(() => {
    console.log("🔄 [useEffect-disableSend] disableSend cambió a:", disableSend);
  }, [disableSend])
  return (
    <>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 800 } }}
        maxWidth="lg"
        TransitionProps={{ onEntering: handleEntering }}
        open={true}      // open={open}
        // {...other}
      >
        <DialogTitle>Seleccione tipo de Envío</DialogTitle>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <ToggleButtonGroup
            color="primary"
            aria-label="outlined primary button group"
            exclusive
            value={shippedType}
            onChange={(e: any, value: string) => setShippedType(value)}
            disabled={disableSend}
          >
            <ToggleButton value="onSite" disabled={disableSend}>Recoger en Tienda</ToggleButton>
            <ToggleButton value="inRoom" disabled={disableSend}>Comedor</ToggleButton>
            <ToggleButton value="shipped" disabled={disableSend}>Domicilio</ToggleButton>
          </ToggleButtonGroup>
        </DialogActions>
        {showDir && (
          <div style={{ marginLeft: "30px", marginRight: "30px" }}>
            <TextField
              margin="normal"
              fullWidth
              name="phone"
              label="Telefono"
              type="phone"
              id="phone"
              value={phone}
              onChange={handlePhone}
              disabled={disableSend}
            />
            <TextField
              margin="normal"
              fullWidth
              name="name"
              label="Nombre"
              type="name"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={disableSend}
            />
            <TextField
              margin="normal"
              fullWidth
              name="name"
              label="Fecha y Hora"
              type="datetime-local"
              id="name"
              value={time}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => setTime(e.target.value)}
              onFocus={(e) => {
                const target = e.target as HTMLInputElement;
                if (target.showPicker) {
                  target.showPicker(); // Safely call the showPicker method
                }
              }}
              disabled={disableSend}
            />
            {shippedType === "shipped" && (
              <>
                <Map
                  setAddress={setAddress}
                  setLocation={setLocation}
                  orderTotal={Number(order.total ?? 0)}
                  setShipping={setShipping}
                  address={address}
                  defaultPoint={{
                    lat: Number(user.user.warehouse.lat),
                    lng: Number(user.user.warehouse.lng),
                  }}
                />
              </>
            )}
          </div>
        )}
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            autoFocus
            onClick={() => modalManager.closeModal()}
            variant="contained"
            color="error"
            style={{ marginRight: "20px" }}
            disabled={disableSend}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOk}
            variant="contained"
            color="success"
            style={{ color: "#fff" }}
            disabled={disableSend}
          >
            {disableSend ? (
              <>
                <CircularProgress size={20} style={{ marginRight: "10px", color: "#fff" }} />
                Procesando...
              </>
            ) : (
              "Ok"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop para bloquear interacción durante el procesamiento */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={disableSend}
      >
        <div style={{ textAlign: "center" }}>
          <CircularProgress color="inherit" size={60} />
          <div style={{ marginTop: "20px", fontSize: "18px" }}>
            Procesando venta...
          </div>
        </div>
      </Backdrop>
    </>
  )
}